// extracted by mini-css-extract-plugin
module.exports = {"eightBall":"questionsArtwork__eightBall__2ceVE","eightBallMessage":"questionsArtwork__eightBallMessage__3icYM"};